import { CLIENT_PERMISSION_REQUIRED_FOR_ROLES, ROLE_OPTIONS_FOR_CLIENT_ADMIN } from "../components/Constants";
import isUndefined from "lodash/isUndefined";

export const isRolePermissible = (role) => {
  const permissionRequires = CLIENT_PERMISSION_REQUIRED_FOR_ROLES[role];
  const enabledFeatures = localStorage.getItem("enabledFeatures");
  const featuresArray = enabledFeatures?.split(",");

  if(isUndefined(permissionRequires)){
    return true;
  }  
  
  return featuresArray?.includes(permissionRequires);
}

export const roleOptionsForClientAdmin = () => {
  return ROLE_OPTIONS_FOR_CLIENT_ADMIN.filter(option => isRolePermissible(option.id))
}